import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto w-full max-w-6xl px-4 md:px-6">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-primary-500 to-accent-500 px-6 py-12 text-center md:py-16">
        <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-background-50/20 blur-2xl" aria-hidden="true"></div>
        <div className="absolute -bottom-10 -right-10 h-40 w-40 rounded-full bg-background-50/20 blur-2xl" aria-hidden="true"></div>

        <div className="relative mx-auto max-w-2xl">
          <h2 className="font-heading text-2xl text-background-50 md:text-3xl">
            {t("final.title")}
          </h2>
          <p className="mt-3 text-sm text-background-50/90 md:text-base">{t("final.text")}</p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap rounded-full bg-background-50 px-8 py-3.5 text-sm font-bold text-foreground-950 transition-transform hover:scale-105"
            >
              {t("buttons.usfans")}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap rounded-full border-2 border-background-50 px-8 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
            >
              {t("buttons.buyNow")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}